import { styled } from '@mui/system'
import { InputAutocomplete as BHInputAutocomplete } from '../../../molecules/input'

export const Root = styled('div')`
	max-width: calc(100% - ${({ theme }) => theme.spacing(6)});
	${({ theme }) => theme.breakpoints.up('md')} {
		max-width: calc(100% - 325px - (20px * 2) - ${({ theme }) => theme.spacing(10)});
	}
	${({ theme }) => theme.breakpoints.up('xl')} {
		max-width: calc(100% - (325px * 2) - (20px * 2) - ${({ theme }) => theme.spacing(10)});
	}
`

export const InputAutocomplete = styled(BHInputAutocomplete)`
	border-radius: ${({ theme }) => theme.shape.borderRadius}px;
	border-color: ${({ theme }) => theme.palette.grey.light};
`
